const WipKeyFileIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 20 20' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 8 12.1 H 9.5 V 17.9 H 8 V 19 H 12 V 17.9 H 10.5 V 12.1 H 12 V 11 H 8 V 12.1 Z M 5.8 11 L 5.6 15.6 L 5.4 18.2 L 5.1 16.1 L 4.7 13 H 3.3 L 2.9 16.1 L 2.6 18.2 L 2.4 15.6 L 2.2 11 H 1 L 1.7 19 H 3.2 L 3.7 16.2 L 4 13.9 L 4 13.8 L 4 13.9 L 4.3 16.2 L 4.8 19 H 6.3 L 7 11 H 5.8 Z M 14 15 H 16 V 12.1 H 14 V 15 Z M 14 19 H 13 V 11 H 16 C 16.6 11 17 11.5 17 12.1 V 15 C 17 15.6 16.6 16.1 16 16.1 H 14 V 19 Z M 17.5 5.3 L 13.8 1.5 L 12.9 2.4 L 15.1 4.6 H 2.5 V 5.9 H 15.1 L 12.9 8.1 L 13.8 9 L 17.5 5.3 Z'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default WipKeyFileIcon;
